$(document).on("vltk_cachep_promotion rendered", {}, function (event, uniqueId) {
    var $this = $("#" + uniqueId);

    // console.log(event);
    // console.log(uniqueId);
    // console.log($this);
    $(".close").each(function () {
        $(this).on("click", function (){
            // $(".popup").removeClass("active")
            $(this).parents(".popup").removeClass("active");
        })
    })
});